// extracted by mini-css-extract-plugin
module.exports = {"portraitHeader":"Portrait_portraitHeader__lK5Kn","feedbackBox":"Portrait_feedbackBox__3Zx0x","feedbackAction":"Portrait_feedbackAction__PusfH"};